import {
 
  anaesthealogy,
  derma,
  radio,
  cardio
} from '../../assets';

export const navLinks = [
  {
    id: 'home',
    title: 'Home',
  },
  {
    id: 'availabledoc',
    title: 'AvailableDoc',
  },
  {
    id: 'makeappointment',
    title: 'MakeAppointment',
  },
];

export const services = [
  {
    title: 'Radiology',
    icon: radio,
  },
  {
    title: 'Dermatology',
    icon: derma,
  },
  {
    title: 'Cardiology',
    icon: cardio,
  },
  {
    title: 'Anesthesiologist',
    icon: anaesthealogy,
  },
];


